import { computed, defineComponent } from 'vue'
import { type JSX } from 'vue/jsx-runtime'

import BookingConfirmation from '@/components/views/booking/BookingConfirmation'
import BookingForm from '@/components/views/booking/BookingForm'
import useLocalization from '@/composables/localization/useLocalization'
import useBookingView from '@/composables/views/booking/useBookingView'

export default defineComponent(() => {
  const { localeTexts } = useLocalization()
  const {
    bookingState,
    allServicesQuery,
    allAdmissionRoomsQuery,
    bookingVisitTimesQuery,
    allDoctorsQuery
  } = useBookingView()

  // #region Getters

  const content = computed((): JSX.Element => {
    if (bookingState.value === 'form') {
      return <BookingForm />
    }

    return <BookingConfirmation />
  })

  // #endregion

  allServicesQuery.execute()
  allAdmissionRoomsQuery.execute()
  bookingVisitTimesQuery.execute()
  allDoctorsQuery.execute()

  return () => (
    <main>
      <div class='mx-auto grid w-full grid-cols-12 px-6 pb-52 pt-6 desktop:w-main-content desktop:px-0'>
        <div class='col-span-2 hidden desktop:block' />
        <div class='col-span-full desktop:col-span-8'>
          <h2 class='text-heading-4'>{localeTexts.value['create-booking-heading']}</h2>
          {content.value}
        </div>
        <div class='col-span-2 hidden desktop:block' />
      </div>
    </main>
  )
}, {
  name: 'BookingView'
})
